<div *ngIf="registration != undefined" (click)="showList = false; $event.stopPropagation();"
    class="row fields-group no-filter faded">
    <div class="col-12">
        <div *ngIf="showList" (click)="showList = !showList;" class="list-overlay-close"></div>
        <div class="list-title d-flex">
            <span class="d-flex w-100 pr-1 title cursor-pointer" (click)="isCollapsed = !isCollapsed">
                {{ 'reg.reqs' | translate }} ({{documentRequirementListLength ? documentRequirementListLength : '0'}})
                <span *ngIf="documentRequirementListLength > 0" class="list-header-collapse-toggle ml-auto">
                    <i class="fa fa-angle-{{isCollapsed ? 'down' : 'up'}}"></i>
                </span>
            </span>
        </div>
        <div class="row p-0 m-0 page-table expanded-list" *ngIf="!isCollapsed">
            <div class="list-group-collapse duo flex-wrap list-item-container" cdkDropList
                [cdkDropListData]="documentRequirementList" (cdkDropListDropped)="dropped($event)">
                <div cdkDrag
                    *ngFor="let documentRequirement of documentRequirementList; let first = first; let last = last; let i = index"
                    class="{{ disabled ? 'list-item-disabled' : 'list-item' }} {{first ? 'first' : ''}} item">
                    <div (click)="openEdit(documentRequirement);$event.stopPropagation();"
                        class="d-flex justify-content-between col">
                        <div class="d-flex align-items-center w-100">
                            <span>{{documentRequirement.requirement.name | translate}}</span>
                            <small class="mb-0 mx-2" *ngIf="documentRequirement?.additionalInformation">
                                <i tooltip="{{documentRequirement?.additionalInformation}}" style="cursor:help"
                                    class="fas fa-info-circle"></i>
                            </small>
                            <div class="d-flex align-items-center"
                                style="margin-inline-start:auto;margin-inline-end:0.5rem;">
                                <span *ngIf="documentRequirement?.bot"
                                    class="fad fa-arrow-right-arrow-left text-warning mr-2"
                                    tooltip="{{documentRequirement?.bot?.name}}"></span>
                                <span
                                    class="btn-circle-icon btn-circle-small btn-danger mr-1 {{documentRequirement?.linkingFileUploadPath ? '' : 'd-none'}}"
                                    [routerLink]="documentRequirement?.linkingFileUploadPathRouterLink"
                                    tooltip="{{ 'modal.requirement_is_linked_with_file_upload_component' | translate }} - {{documentRequirement?.linkingFileUploadPathTitle}}"><i class="far fa-cloud-arrow-up"></i></span>
                                <span
                                    class="btn-circle-icon btn-circle-small btn-pink mr-1 {{documentRequirement?.toUpload ? '' : 'd-none'}}"
                                    tooltip="{{ 'modal.requirement_to_upload' | translate }}"><i class="far fa-file-arrow-up"></i></span>
                                <span
                                    class="btn-circle-icon btn-circle-small btn-success mr-1 {{documentRequirement?.toShow ? '' : 'd-none'}}"
                                    tooltip="{{ 'modal.requirement_to_show' | translate }}"><i class="far fa-id-card"></i></span>
                                <span
                                    class="btn-circle-icon btn-circle-small btn-primary mr-1 {{documentRequirement?.toSign ? '' : 'd-none'}}"
                                    tooltip="{{ 'modal.requirement_to_sign' | translate }}"><i class="far fa-signature"></i></span>
                                <span
                                    class="btn-circle-icon btn-circle-small btn-secondary mr-1 {{documentRequirement?.multiple ? '' : 'd-none'}}"
                                    tooltip="{{ 'modal.requirement_is_multiple' | translate }}">
                                    <i class="fa-solid fa-files"></i>
                                </span>
                                <span
                                    class="btn-circle-icon btn-circle-small btn-purple mr-1 {{documentRequirement?.usedAsADatabase ? 'active' : 'd-none'}}"
                                    tooltip="{{ 'Extract Data from file' | translate }}">
                                    <i class="fa-solid fa-wand-magic-sparkles"></i>
                                </span>
                                <span
                                    class="btn-circle-icon btn-circle-small btn-default mr-1 {{documentRequirement?.toPrintUpload ? '' : 'd-none'}}"
                                    tooltip="{{ 'modal.requirement_to_print_upload' | translate }}"><i class="far fa-print"></i></span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center"
                            (click)="determinantAllowed(documentRequirement) && openEdit(documentRequirement, true); $event.stopPropagation();">
                            <det-popover [extraClasses]="hasDeterminant(documentRequirement) ? 'active' : (determinantAllowed(documentRequirement) ? '' : 'disallowed')"
                                [determinant]="documentRequirement.jsonDeterminants" [placement]="'top'"
                                [hasErrors]="hasError(documentRequirement.id)"
                                [noneSelectedText]="determinantAllowed(documentRequirement) ? ('Add determinant' | translate) : ('No determinants allowed for linked requirements' | translate)"
                                [determinantMapById]="determinantMapById"></det-popover>
                        </div>
                        <div class="d-flex align-items-center">
                            <business-key *ngIf="documentRequirement.requirement.businessKey" class="mr-auto"
                                [businessKey]="documentRequirement.requirement.businessKey"
                                [businessKeyTooltip]="'Document business key' | translate" [extraClass]="'mr-2'">
                            </business-key>
                        </div>
                        <div class="d-flex align-items-center" *ngIf="!disabled">
                            <confirmation [showTrashIcon]="true" [question]="'confirm.areyousure'"
                                [extraClasses]="'d-flex'" (click)="$event.stopPropagation();"
                                (isConfirmed)="deleteDocumentRequirement($event, documentRequirement.id)">
                            </confirmation>
                        </div>
                    </div>
                    <div *cdkDragPreview class="col-4">
                        <div>
                            {{documentRequirement.requirement.name | translate}}
                        </div>
                    </div>
                </div>
            </div>
            <!--
                    <div class="w-100 position-relative list-item-container" *ngIf="!disabled">
                        <div class="list-item item last add-item {{showList ? 'opened' : ''}}"
                            (click)="showOrAdd(); $event.stopPropagation();">
                            <div class="d-flex w-100 justify-content-between list-itemPart first">
                                <div class="{{showList ? 'hidden' : ''}}">
                                    <span *ngIf="requirements?.length > 0"><i class="fal fa-plus"></i> {{'Select or add new' | translate}}</span>
                                    <span *ngIf="requirements?.length == 0"><i class="fal fa-plus"></i> {{'Add new' | translate}}</span>
                                </div>
                                <input [(ngModel)]="searchRequirementFilter.name" (click)="$event.stopPropagation();" placeholder="{{ 'Search' | translate }}" type="text" class="{{showList ? '' : 'hidden'}} select-search" />
                                <span (click)="openEdit(false);$event.stopPropagation();"
                                    class="btn btn-primary text-white ml-auto {{showList ? '' : 'hidden'}}">{{'Add' | translate}}</span>
                            </div>
                        </div>
                        <div class="w-100 list-item-group limit-height-200 vertical-scroll" *ngIf="requirements.length > 0">
                        <div *ngFor="let requirement of requirements | filterBy: searchRequirementFilter; let first = first; let last = last; let i = index"
                                (click)="addDocumentRequirement(requirement);$event.stopPropagation();"
                                class="list-item w-100 select-item {{showList ? '' : 'hidden'}} {{last ? 'last' : ''}}">
                            <div class="d-flex justify-content-between list-itemPart first">
                                <div class="d-flex align-items-center w-100">
                                    <div>{{requirement.name}}</div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                -->
            <drawer-items class="mt-1" [items]="requirements" [title]="'reg.reqs'"
                (itemSelected)="addDocumentRequirements($event)" [showAddButton]="true"
                [openListButtonLabel]="'Select or add new'" (askForNew)="openEdit(false, false, $event)"></drawer-items>
        </div>
    </div>
</div>